import { cn } from '@/lib/utils';
import type { StatusKey } from '@/types';

/** Couleur (hex) associée à chaque clé de statut, alignée sur les tokens CSS. */
const STATUS_COLOR: Record<StatusKey, string> = {
  done: '#00C875',
  working: '#F97316',
  stuck: '#E2445C',
  pending: '#C4C4C4',
  info: '#0073EA',
  review: '#A25DDC',
};

export interface StatusBadgeProps {
  status: StatusKey;
  label: string;
  className?: string;
  /** Variante pleine (fond coloré) façon Monday, ou douce (fond teinté). */
  variant?: 'soft' | 'solid';
}

/**
 * Pill colorée avec point de couleur à gauche.
 * Brief — composant #1.
 */
export function StatusBadge({ status, label, className, variant = 'soft' }: StatusBadgeProps) {
  const color = STATUS_COLOR[status];

  if (variant === 'solid') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold text-white',
          className,
        )}
        style={{ backgroundColor: color }}
      >
        <span className="size-1.5 rounded-full bg-white/90" />
        {label}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold',
        className,
      )}
      style={{ backgroundColor: `${color}1A`, color }}
    >
      <span className="size-1.5 rounded-full" style={{ backgroundColor: color }} />
      {label}
    </span>
  );
}
